/* eslint-disable no-console */
import VTextField from 'vuetify/lib/components/VTextField/VTextField';

let DecimalEditor = VTextField.extend({
  props: {
    scale: { type: Number, default: 2 }
  },
  created () {
    if (this.value || this.value == 0) this.internalValue = this.Utility.toNumber(this.value, this.scale);
  },
  methods: {
    onKeyDown (e) {
      let code = e.keyCode;
      if (code == 13) {
        let value = e.target.value;
        if (value || value === 0 || value === '0') {
          value = this.Utility.toNumber(value, this.scale);
          this.internalValue = value;
        }
        e && this.$emit('change', value);
        return;
      }
      let pos = e.target.selectionStart;
      let b1 = (e.ctrlKey || e.metaKey) && (code == 67 || code == 86 || code == 88 || code == 65); // Ctrl/Command+[c、v、x、a]
      let b2 = (code >= 48 && code <= 57) || (code >= 96 && code <= 105) || code == 173; // 0-9,小键盘0-9，-
      let b3 = code >= 37 && code <= 40; // 左上右下
      let b4 = code == 8 || code == 9 || code == 190 || code == 110 || code == 16; // 回退、tab、点、小键盘点、Shift
      let dotIdx = this.lazyValue ? String(this.lazyValue).indexOf('.') : -1;
      let minusIdx = this.lazyValue ? String(this.lazyValue).indexOf('-') : -1;
      if (
        (!b1 && !b2 && !b3 && !b4)
        || (code == 190 && !this.lazyValue)
        || (code == 173 && (pos != 0 || minusIdx != -1))
        || (code == 190 && dotIdx != -1)
      ) {
        e.returnValue = false;
      } else {
        this.$emit('keydown', e);
      }
    },
    onBlur (e) {
      let value = e.target.value;
      if (value || value === 0 || value === '0') {
        value = this.Utility.toNumber(value, this.scale);
        this.internalValue = value;
      }
      this.isFocused = false;
      e && this.$nextTick(() => this.$emit('blur', e));
    }
  }
})

export default {
  install: function (Vue) {
    Vue.component('decimal-editor', DecimalEditor)
  }
}